<template>
    <div>
        <div class="is-main f-mb15">
            <div class="container">
                <section class="m-location f-mb10">
                    <span>当前位置：</span>
                    <a href="/">网站首页</a> &gt;
                    <a>交易信息</a>
                </section>
                <div class="m-pgpdbox1">

                    <div class="row f-mlrf10">
                        <section class="col-md-3 f-plr10 m-listlf f-md-mb15">
                            <div class="g-listlf hidden-sm hidden-xs">
                                <h1 class=" u-tit">
                                    <span></span>
                                    交易信息
                                </h1>
                                <ul>
                                    <li v-for="(item, index) in tradeTypeList" :key="index"
                                        :class="index == activeIndex ? 'u-active' : ''"
                                        @click="handleSelectChild(index)">
                                        <a :title="item.name">{{ item.name }}</a>
                                    </li>
                                </ul>
                            </div>
                        </section>

                        <section class="col-md-9 f-plr10 m-listrg">
                            <div style=" padding: 10px 0;">
                                <div style="display: flex;gap: 10px;margin-bottom: 10px">
                                    <el-input v-model="queryData.title"  prefix-icon="el-icon-search" placeholder="请输入项目名称"/>
                                    <el-button type="primary" @click="getTradeInfoList"> 搜索</el-button>
                                </div>
                                <template
                                    v-if="tradeTypeList[activeIndex].id != 5 && tradeTypeList[activeIndex].id != 6">
                                    <el-tabs stretch v-model="queryData.progressStatus" @tab-click="onProgressClick">
                                        <el-tab-pane v-for="item in progressStatusList" :key="item.id"
                                            :label="item.name" :name="item.id">
                                        </el-tab-pane>
                                    </el-tabs>
                                </template>
                                <template v-else>
                                    <div class="m-titstyle1 f-clearfix f-mb5">
                                        <span class="u-tit f-fl"
                                            v-if="tradeTypeList[activeIndex].id == 5">经营管理<em></em></span>
                                        <span class="u-tit f-fl" v-else>供方管理<em></em></span>
                                    </div>
                                </template>
                            </div>

                            <div class="m-cglist m-liststyle1 f-md-mb15">
                                <ul>
                                    <li v-for="(item, index) in tradeList" :key="index" @click="handeleNavigate(item)">
                                        <span>{{ formDate(item.time) }}</span>
                                        <a :title="item.name" target="_blank">{{ item.title }}</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="text-right m-paginationyun7">
                                <div id="pagination" class="f-fr">

                                    <el-pagination layout="prev, pager, next,jumper" :current-page.sync="page" :page-size="15" :total="total"
                                        @current-change="handleCurrenChange">
                                    </el-pagination>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api/api'

export default {
    name: "channel",
    data() {
        return {
            cateInfo: {},
            childList: [],
            tradeList: [],
            activeIndex: -1,
            total: 0,
            page: 1,
            tradeTypeList: this.$store.getters.tradeTypeList,
            progressStatusList: [{
                id: '1',
                name: "项目登记"
            }, {
                id: '2',
                name: "采购公告"
            }, {
                id: '9',
                name: "中标候选人公示"
            }, {
                id: '4',
                name: "中标结果公告"
            }, {
                id: '3',
                name: "更正公告"
            }, {
                id: '6',
                name: "合同公告"
            }, {
                id: '7',
                name: "暂停、终止招标"
            }],
            queryData: {
                progressStatus: '1',
                title:''
            }
        }
    },
    created() {
        this.page = 1;
        this.loading()
    },
    methods: {

        handleCurrenChange(val) {
            this.page = val;
            this.getTradeInfoList();
        },
        loading() {

            this.handleSelectChild(this.$route.query.index)
        },
        onProgressClick() {
            this.page = 1;
            this.tradeList = [];
            this.total = 0;
            this.getTradeInfoList();
        },

        getTradeInfoList() {
            api.getTradeInfoList({
                page: this.page,
                size: 15,
                status: 1,
                siteId: this.$store.state.siteId,
                type: this.tradeTypeList[this.activeIndex].id,
                progress: this.queryData.progressStatus,
                title: this.queryData.title,
            }).then(res => {
                this.tradeList = res.content
                this.total = res.total
            })
        },
        handleSelectChild(index) {
            this.queryData.progressStatus = '1';
            this.page = 1;
            this.tradeList = [];
            this.total = 0;
            this.activeIndex = index
            this.getTradeInfoList();

        },
        handeleNavigate(item) {
            // console.log('item', item)
            if (item.parentId > 0) {
                this.$router.push({
                    path: `/tradeDetail/${item.parentId}/${item.progress}/`
                })
            } else {
                this.$router.push({
                    path: `/tradeDetail/${item.id}/${item.progress}/`
                })
            }

        }
    },
    watch: {
        '$store.state.activeId': function () {
            this.activeIndex = -1
            this.loading()
        }
    },
    computed: {
        formDate() {    // JS 不同时间格式转换(ISO时间&时间戳转北京时间)
            return date => {
                return date.substr(0, 10)
            }
        }
    }
}
</script>

<style scoped></style>
